module.exports = function($, CQ, CDD) {
    class Vote {

        constructor() {
            this.mapg = [];
            this.total = 11;
            this.bulletinVote = {
                vote: 0,
                list: 0,
                results: {
                    lists: [],
                    candidats: []
                },
                start: false,
                status: ''
            };

            this.LetzvoteCommunales = (typeof LetzvoteCommunales != 'undefined')? LetzvoteCommunales : {};

            this.init();
            this.bind();
            this.markup_vote();
            this.markup_map();
        }

        init(){
            this.current_commune = {};
            this.Container = $('.page-template-tpl-communales .block-pratique-vote');

            if( this.Container.length == 0 ){
                return;
            }

            let s = sessionStorage.getItem('CommunalesVote');
            if (s) {
                this.bulletinVote = JSON.parse(s);
            }

            this.load();

            s = sessionStorage.getItem('CommunalesCommune');
            if( s ){
                this.current_commune = JSON.parse(s);
            }

            let _this = this;
            this.Container.find('.map g[data-name]').each(function(){
                let n = $(this).attr('data-name');
                let id = $(this).attr('id');
                _this.mapg.push({
                    id: id,
                    text: n
                });
            })
        }

        load(){
            let s = sessionStorage.getItem('LetzvoteCommunales');
            if( s ){
                this.LetzvoteCommunales = JSON.parse(s);
            }
        }

        clear_all(){
            this.bulletinVote = {
                vote: 0,
                list: 0,
                results: {
                    lists: [],
                    candidats: []
                },
                start: false,
                status: ''
            };
            this.LetzvoteCommunales.score = 0;
            this.LetzvoteCommunales.trials = {
                bulletinVote: 0,
                quizz: 0,
                dragandrop: 0
            };
            // this.LetzvoteCommunales.trials.bulletinVote = 0;
            // this.LetzvoteCommunales.trials.quizz = 0;
            // this.LetzvoteCommunales.trials.dragandrop = 0;
            this.LetzvoteCommunales.number = 0;

            this.current_commune = {};

            sessionStorage.setItem('CommunalesCommune', JSON.stringify(this.current_commune) );
            sessionStorage.setItem('CommunalesVote', JSON.stringify(this.bulletinVote) );
            sessionStorage.setItem('LetzvoteCommunales', JSON.stringify(this.LetzvoteCommunales) );

            CQ.clear_all();
            CDD.clear_all();

            this.markup_vote();
            this.markup_map();

            $('[data-group="pratique"]').removeClass('active');
            $('#pratique--1').addClass('active');
        }

        bind(){
            // let _array = [];
            let _this = this;

            this.Container.find('.social a').on('click', function(e){
                e.preventDefault();
                let onclick = $(this).attr('href');
                onclick = onclick.replace('X', _this.LetzvoteCommunales.score);
                window.open(onclick, '_blank', ',width=600,height=600');
            });

            this.Container.find('.search .send').on("click", function(e){
                let id = _this.Container.find('.search .overlayer div.active').attr('data-id');
                _this.Container.find('.search .overlayer').removeClass('active');
                _this.get_commune(id);
            });

            this.Container.find('.search').on("click", ".overlayer div", function(e){
                let id = $(this).attr('data-id');
                _this.Container.find('.search .overlayer').removeClass('active');
                _this.Container.find('.search input').val($(this).text());
                _this.get_commune(id);
            });

            this.Container.find('.search input').on("focusout", function(e){
                let __this = _this;
                setTimeout(function(){
                    __this.Container.find('.search .overlayer').removeClass('active');
                })
            });

            this.Container.find('.search input').on("keyup", function(e){
                let v = $(this).val();
                let regex = new RegExp( v, "i");
                let html = "";
                let index;

                _this.Container.find('.search .overlayer').addClass('active');

                if( v == '' ){
                    _this.Container.find('.search .overlayer').html('');
                    _this.Container.find('.search .overlayer').removeClass('active');
                    return;
                }

                if( e.keyCode == 13 ){
                    let t = _this.Container.find('.search .overlayer div.active').text();
                    let id = _this.Container.find('.search .overlayer div.active').attr('data-id');
                    $(this).val(t);
                    _this.Container.find('.search .overlayer').removeClass('active');
                    _this.get_commune(id);
                    return;
                }

                if( e.keyCode == 38 ){
                    index = _this.Container.find('.search .overlayer div.active').index();
                    index = parseInt(index);
                    if( _this.Container.find('.search .overlayer div:nth-child('+index+')').length ){
                        _this.Container.find('.search .overlayer div').removeClass('active');
                        _this.Container.find('.search .overlayer div:nth-child('+index+')').addClass('active');
                    }
                    return;
                }
                if( e.keyCode == 40 ){
                    index = _this.Container.find('.search .overlayer div.active').attr('data-index');
                    index = parseInt(index) + 1;
                    if( _this.Container.find('.search .overlayer div:nth-child('+index+')').length ){
                        _this.Container.find('.search .overlayer div').removeClass('active');
                        _this.Container.find('.search .overlayer div:nth-child('+index+')').addClass('active');
                    }
                    return;
                }
                let k = 0;
                for( let i in _this.mapg ){
                    let m = _this.mapg[i].text;
                    let _class = "";
                    if( m.match(regex) ){
                        if( html == "" ){
                            _class = "active";
                        }
                        k++;
                        html += "<div class='"+_class+"' data-id='"+_this.mapg[i].id+"' data-index='"+k+"'>"+m+"</div>";
                    }
                }
                _this.Container.find('.search .overlayer').html(html);
            });

            this.Container.find('.clear-all').on('click', function(e){
                _this.clear_all();
            })

            this.Container.find('.start-bulletin-vote').on('click', function(e){
                e.preventDefault();
                _this.bulletinVote.start = true;
                _this.markup_vote();
                $("html, body").animate({ scrollTop: _this.Container.find('.grids').offset().top - 100 }, 400 );
            })

            this.Container.find('.submit-bulletin-vote').on('click', function(e){
                e.preventDefault();
                _this.vote_resolve();
            });

            this.Container.find('.map g[data-name]').on('click',function (e) {
                let id = $(this).attr('id');
                _this.get_commune(id);
            });

            this.Container.find('.map g[data-name]').on('mouseover',function (e) {
                let name = $(this).attr('data-name');
                $(".text-mouse").css({"left":e.pageX + 'px', "top": e.pageY + 'px', 'opacity': 1});
                $(".text-mouse").text(name);
            });

            $(window).on('resize', function () {
                let a = _this.Container.find('.map g[data-name].active');
                if( a.length ){
                    let X = a.offset().left;
                    let Y = a.offset().top;
                    $(".text-mouse").css({"left":X + 'px', "top": Y + 'px'});
                }
            })

            this.Container.find('.map g[data-name]').on('mouseout', function(e) {
                $(".text-mouse").css({'opacity': 0});
            });

            this.Container.find('.candidat-vote').on('click', function(e){
                $(this).toggleClass('checked');
                if( $(this).hasClass('checked') ){
                    _this.bulletinVote.vote += 1;
                } else {
                    _this.bulletinVote.vote -= 1;
                }
                let candidat = $(this).attr('data-candidat');
                let vote = $(this).attr('data-vote');
                let list = $(this).attr('data-list');
                let _class = `list-${list}-candidat-${candidat}-vote-${vote}`;
                if(_this.bulletinVote.results.candidats.includes(_class) ){
                    let index = _this.bulletinVote.results.candidats.indexOf(_class);
                    _this.bulletinVote.results.candidats.splice(index, 1);
                } else {
                    _this.bulletinVote.results.candidats.push(`list-${list}-candidat-${candidat}-vote-${vote}`);
                }

                sessionStorage.setItem('CommunalesVote', JSON.stringify(_this.bulletinVote) );

                _this.markup_vote();
            });

            this.Container.find('.list-vote').on('click', function(){
                $(this).toggleClass('checked');
                if( $(this).hasClass('checked') ){
                    _this.bulletinVote.list += 1;
                } else {
                    _this.bulletinVote.list -= 1;
                }
                let list = $(this).attr('data-list');
                if(_this.bulletinVote.results.lists.includes(list) ){
                    let index = _this.bulletinVote.results.lists.indexOf(list);
                    _this.bulletinVote.results.lists.splice(index, 1);
                } else {
                    _this.bulletinVote.results.lists.push(list);
                }

                sessionStorage.setItem('CommunalesVote', JSON.stringify(_this.bulletinVote) );

                _this.markup_vote();
            });

            this.Container.find('.clear-bulletinVote').on('click', function(e){
                e.preventDefault();
                _this.bulletinVote = {
                    vote: 0,
                    list: 0,
                    results: {
                        lists: [],
                        candidats: []
                    },
                    start: true,
                    status: ''
                };

                if( _this.LetzvoteCommunales.trials.bulletinVote != 0 ){
                    _this.LetzvoteCommunales.score -= _this.total;
                }
                _this.LetzvoteCommunales.trials.bulletinVote = 0;
                _this.LetzvoteCommunales.number -= 1;

                sessionStorage.setItem('CommunalesVote', JSON.stringify(_this.bulletinVote) );
                sessionStorage.setItem('LetzvoteCommunales', JSON.stringify(_this.LetzvoteCommunales) );

                $("html, body").animate({ scrollTop: $('.block-pratique').offset().top - 100 }, 400 );
                _this.markup_vote();
            });
        }

        markup_vote(){
            // console.log(this.bulletinVote);
            if( this.Container.length == 0 ){
                return;
            }

            let _this = this;
            this.Container.find('.grids').removeClass('active');
            this.Container.find('.bubble-1').removeClass('active');

            if( this.bulletinVote.start == true ){
                this.Container.find('.bubble-1.' + this.current_commune.communales.scrutin ).addClass('active');
                this.Container.find('.grids').addClass('active');
                this.Container.find('.grids').attr('data-scrutin', this.current_commune.communales.scrutin);
                setTimeout(function () {
                    let top = _this.Container.find('.bubble-1.active').offset().top - _this.Container.find('.pratique-vote--content').offset().top;
                    _this.Container.find('.drawing').css({'top': top + 'px'});
                },1000);
            }

            let voix = 0;

            if( Object.keys(this.current_commune).length !== 0 ){
                voix = this.current_commune.communales.mandats - this.bulletinVote.vote;
            }

            if( this.bulletinVote.list > 0 ){
                voix = 0;
            }
            voix = (voix<0)? 0 : voix;
            if( Object.keys(this.current_commune).length !== 0 ) {
                voix += '/' + this.current_commune.communales.mandats;
            }
            this.Container.find('.tongue span').text(voix);

            this.Container.find('.grid-item-row').addClass('d-none');

            if( Object.keys(this.current_commune).length !== 0 ) {
                for(let i=1; i<=this.current_commune.communales.candidat;i++){
                    this.Container.find('.grid-item-row-'+i).removeClass('d-none');
                }
            }

            this.Container.find('.list-vote').removeClass('checked');
            for (let j in this.bulletinVote.results.lists) {
                this.Container.find('.list-vote[data-list="'+this.bulletinVote.results.lists[j]+'"]').addClass('checked');
            }

            this.Container.find('.candidat-vote').removeClass('checked');
            for (let j in this.bulletinVote.results.candidats) {
                this.Container.find(`.candidat-vote.${this.bulletinVote.results.candidats[j]}`).addClass('checked');
            }

            this.Container.find('.grid-item').addClass('d-none');
            if( Object.keys(this.current_commune).length !== 0 ) {
                for (let k=1; k<=this.current_commune.communales.lists; k++) {
                    this.Container.find(`.grid-item.list-${k}`).removeClass('d-none');
                }
            }

            if( this.LetzvoteCommunales.score < this.LetzvoteCommunales.total / 2 ){
                this.Container.find('.content-global').removeClass('d-none');
            } else {
                this.Container.find('.content-global').addClass('d-none');
            }

            if( this.bulletinVote.status == 'failed' ){
                this.Container.find('.note').text("0 / " + this.total);
                this.Container.find('.message.alert-warning').removeClass('d-none');
                this.Container.find('.message.alert-success').addClass('d-none');
                setTimeout(function() {
                    if( $('[data-group="pratique"].active .block-pratique-vote .message.alert-warning').length > 0 && $('[data-group="pratique"].active .block-pratique-vote .message.alert-warning').offset().top != 0 ) {
                        $("html, body").animate({scrollTop: _this.Container.find('.message.alert-warning').offset().top - 100}, 200);
                    }
                }, 800);
                this.Container.find('.candidat-vote').addClass('disabled');
                this.Container.find('.list-vote').addClass('disabled');

            } else if( this.bulletinVote.status == 'successful' ){
                this.Container.find('.note').text(this.total + " / " + this.total);
                this.Container.find('.message.alert-warning').addClass('d-none');
                this.Container.find('.message.alert-success').removeClass('d-none');
                setTimeout(function() {
                    if( $('[data-group="pratique"].active .block-pratique-vote .message.alert-success').length > 0 && $('[data-group="pratique"].active .block-pratique-vote .message.alert-success').offset().top != 0 ) {
                        $("html, body").animate({ scrollTop: _this.Container.find('.message.alert-success').offset().top - 100 }, 200 );
                    }
                }, 800);
                this.Container.find('.candidat-vote').addClass('disabled');
                this.Container.find('.list-vote').addClass('disabled');

            } else {
                this.Container.find('.message.alert-warning').addClass('d-none');
                this.Container.find('.message.alert-success').addClass('d-none');
                this.Container.find('.candidat-vote').removeClass('disabled');
                this.Container.find('.list-vote').removeClass('disabled');
            }

            $('.score_global').html(this.LetzvoteCommunales.score + " / " + this.LetzvoteCommunales.total);

        }

        markup_map(){
            this.Container.find('.map g[data-name]').removeClass('active');
            this.Container.find('.box').removeClass('active');
            if( !$.isEmptyObject(this.current_commune) ){
                this.Container.find('.box').addClass('active');
                this.Container.find(".name").text(this.current_commune.name);
                this.Container.find(".number").html(this.current_commune.communales.html.residents_total);
                this.Container.find(".scrutin").html(this.current_commune.communales.html.scrutin);
                this.Container.find(".conseillers").html(this.current_commune.communales.html.mandats);
                this.Container.find('.map g[data-name]#'+this.current_commune.id).addClass('active');
                this.Container.find('.search input').val(this.current_commune.name);
            }
        }

        get_commune(id){
            let _this = this;
            _this.bulletinVote = {
                vote: 0,
                list: 0,
                results: {
                    lists: [],
                    candidats: []
                },
                start: true,
                status: ''
            };
            if( id ){
                $.ajax({
                    type: "POST",
                    url: WP.ajaxurl,
                    data: {
                        action: 'get_commune',
                        id: id
                    },
                    success: function (data) {
                        _this.current_commune = data;
                        sessionStorage.setItem('CommunalesCommune', JSON.stringify(data) );
                        _this.markup_map();
                        _this.markup_vote();
                    }
                });
            }
        }

        vote_resolve(){

            this.load();

            if( this.current_commune.communales.lists == 1 ){
                this.bulletinVote.status = 'successful';
                this.LetzvoteCommunales.score += this.total;
                this.LetzvoteCommunales.trials.bulletinVote = this.total;

                if( this.bulletinVote.vote > this.current_commune.communales.mandats || this.bulletinVote.vote == 0 ){
                    this.LetzvoteCommunales.score -= this.total;
                    this.bulletinVote.status = 'failed';
                    this.LetzvoteCommunales.trials.bulletinVote = 0;
                }

            }

            if( this.current_commune.communales.lists == 3 ){
                this.bulletinVote.status = 'successful';
                this.LetzvoteCommunales.score += this.total;
                this.LetzvoteCommunales.trials.bulletinVote = this.total;

                if( this.bulletinVote.vote > this.current_commune.communales.mandats ){
                    this.LetzvoteCommunales.score -= this.total;
                    this.bulletinVote.status = 'failed';
                    this.LetzvoteCommunales.trials.bulletinVote = 0;
                }
                if( this.bulletinVote.list > 1 ){
                    this.LetzvoteCommunales.score -= this.total;
                    this.bulletinVote.status = 'failed';
                    this.LetzvoteCommunales.trials.bulletinVote = 0;
                }
                if( this.bulletinVote.list == 1 && this.bulletinVote.vote > 0 ){
                    this.LetzvoteCommunales.score -= this.total;
                    this.bulletinVote.status = 'failed';
                    this.LetzvoteCommunales.trials.bulletinVote = 0;
                }
                if( this.bulletinVote.list == 0 && this.bulletinVote.vote == 0 ){
                    this.LetzvoteCommunales.score -= this.total;
                    this.bulletinVote.status = 'failed';
                    this.LetzvoteCommunales.trials.bulletinVote = 0;
                }
            }


            this.LetzvoteCommunales.number += 1;

            sessionStorage.setItem('LetzvoteCommunales', JSON.stringify(this.LetzvoteCommunales) );
            sessionStorage.setItem('CommunalesVote', JSON.stringify(this.bulletinVote) );

            this.markup_vote();
        }

    }

    return new Vote();
}
